<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.data)">
        <span>{{ organizationTypeString(params.data) }}</span>
    </vs-chip>
</template>

<script>
export default {
    name: 'CellRendererStatus',
    computed: {
        chipColor() {
            return value => {
                if (value.status === 0) {
                    return "danger"
                } else if (value.status === 1) {
                    return "success"
                } else if (value.status === 2) {
                    return "warning"
                }
            }
        },
        organizationTypeString() {
            return value => {
                if (value.status === 0) {
                    return this.$t('invoice.haventPaidYet')
                } else if (value.status === 1) {
                    return this.$t('invoice.paid')
                } else if (value.status === 2) {
                    return this.$t('invoice.paying')
                }
            }
        }
    }
}
</script>

<style lang="scss" scpoped>
</style>
